<template>
  <img
    v-if="!failed"
    class="card-face"
    :class="[sizeClass, { 'card-back': faceDown }]"
    :src="src"
    :alt="alt"
    loading="lazy"
    @error="failed = true"
  />
  <!--
    The art is 33 committed JPEGs, so a miss means a genuinely broken deploy
    rather than a slow network - but a card whose number you cannot read makes
    the game unplayable, so the fallback prints the number instead of showing
    a broken-image icon. Same aspect-ratio box either way, so nothing reflows.
  -->
  <div
    v-else
    class="card-face card-face--placeholder"
    :class="sizeClass"
    :aria-label="alt"
  >{{ faceDown ? '?' : value }}</div>
</template>

<script>
export default {
  name: 'CardFace',
  props: {
    value: { type: Number, default: null },
    faceDown: { type: Boolean, default: false },
    size: { type: String, default: 'chip' }, // 'chip' | 'table'
  },
  data() {
    return { failed: false };
  },
  computed: {
    src() {
      const name = this.faceDown ? 'back' : this.value;
      return `${process.env.BASE_URL || '/'}card-art/${name}.jpg`;
    },
    alt() {
      return this.faceDown ? 'Face-down card' : `Card ${this.value}`;
    },
    sizeClass() {
      return this.size === 'table' ? 'card-face--table' : null;
    },
  },
  watch: {
    // A recycled <img> that failed once must get a fresh chance when the
    // value changes, or one bad load would poison that slot for the rest of
    // the game.
    value() { this.failed = false; },
    faceDown() { this.failed = false; },
  },
};
</script>
